<!-- Todo: the below style class needs to be modified to enable the focus -->
<div [ngClass]="['modal', style, side]" [class.modal--open]="_open" #modal>
  <div [ngClass]="['modal-body-header', type]" *ngIf="showHeader">
    <h1 class="modal-body-header-title">{{ spTitle }}</h1>
    <button class="modal-body-header-close" (click)="onToggleEvent()">
      <sp-icon name="close" size="small" type="solid" [inherit]="true"></sp-icon>
    </button>
  </div>

  <div class="modal-body"><ng-content></ng-content></div>

  <div class="modal-actions" *ngIf="actions && actions.length > 0">
    <ng-template ngFor let-action [ngForOf]="actions" let-page="index">
      <div class="button-container">
        <sp-button
          *ngIf="action.label !== 'cancel'"
          [class]="action.style"
          [size]="action.size"
          [style]="action.style"
          [disabled]="action.disabled"
          [status]="action.status"
          [label]="action.label"
          [icon]="action.icon"
          (clickAction)="action.action()"
        ></sp-button>
        <sp-button
          *ngIf="action.label === 'cancel'"
          [class]="action.style"
          [size]="action.size"
          [style]="action.style"
          label="إلغاء"
          [icon]="action.icon"
          (clickAction)="onToggleEvent()"
        ></sp-button>
      </div>
    </ng-template>
  </div>
</div>
<div *ngIf="open" class="modal-overlay overlay overlay--dark" (click)="onToggleEvent()" #overly></div>
